import React, { useCallback, useState } from "react";
import StudentDashboard from "../../../layout/StudentDashboard";
import { useGetTutorsQuery } from "../../../hooks/api/Students/Tutors/useGetTutorsQuery";
import {
  BriefcaseBusiness,
  ChevronDown,
  RefreshCcw,
  X,
  Calendar,
} from "lucide-react";
import { Button, Drawer, Modal, Tabs } from "antd";
import AvailabilityBadge from "./Components/AvailabilityBadge";
import Loader from "../../../components/Loader";
import { useGetTutorQuery } from "../../../hooks/api/Students/Tutors/useGetTutorQuery";
import { useGetSubjectsQuery } from "../../../hooks/api/Admin/Courses/useGetSubjectsQuery";
import { debounce } from "lodash";
import SearchFilters from "./Components/SearchFilters";
import EmptyState from "../../../components/EmptyState";
import TutorBookingStepper from "./Components/TutorBookingStepper";

const initialState = {
  areaOfExpertise: "",
  search: "",
  days: "",
  from: "",
  to: "",
};

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const StudentTutors = () => {
  const [id, setId] = useState("");
  const [visible, setVisible] = useState(false);
  const [payload, setPayload] = useState(initialState);

  const { isLoading, data } = useGetTutorsQuery({ payload });
  const { data: tutorsData, isLoading: tutorsLoading } = useGetTutorQuery({
    id,
    payload,
  });

  const pfp = require("../../../assets/images/pfpavatar.jpg");

  const tutorsList = data?.data?.docs;

  const { data: subjects } = useGetSubjectsQuery({ page: 1, limit: 100 });
  const [openModal, setOpenModal] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearch = useCallback(
    debounce((value: string) => {
      setPayload((prev) => ({ ...prev, search: value }));
    }, 1000),
    [setPayload]
  );

  // if (isLoading && !data) {
  //   return (
  //     <StudentDashboard>
  //       <Loader />
  //     </StudentDashboard>
  //   );
  // }

  return (
    <StudentDashboard>
      <div className="md:flex block gap-5">
        <div className="md:w-[300px] w-full">
          <div className="md:mb-0 mb-[20px]">
            <div className="fixed bg-white shadow-sm rounded-md w-[93%] md:w-[300px]">
              <div className="px-[18px] py-[20px] flex items-center justify-between">
                <span className="W2STMedium">Filter Options</span>
                <span className="flex gap-3 items-center">
                  <button
                    className="p-2 bg-white rounded-full shadow-md"
                    onClick={() => {
                      setPayload(initialState);
                    }}
                  >
                    <RefreshCcw />
                  </button>{" "}
                  <button
                    className="p-2 bg-white rounded-full shadow-md md:hidden block"
                    onClick={() => {
                      setOpenModal(!openModal);
                    }}
                  >
                    <ChevronDown />
                  </button>
                </span>
              </div>
              <Modal
                onCancel={() => setOpenModal(false)}
                title={"Filter Options"}
                open={openModal}
                footer={<Button variant="filled">Confirm</Button>}
              >
                {/* <SearchFilters
                  handleSearch={handleSearch}
                  setPayload={setPayload}
                  payload={payload}
                  subjects={subjects}
                  daysOfWeek={daysOfWeek}
                /> */}
              </Modal>

              <div className="md:block hidden text-[10px]">
                {/* {JSON.stringify(subjects?.data?.categories?.["High School"])}
                <br />
                <br />
                {JSON.stringify(
                  subjects?.data?.categories?.["Middle School 6-8"]
                )}
                <br />
                <br />
                {JSON.stringify(subjects?.data?.categories?.["Elementary K-5"])} */}
                <SearchFilters
                  handleSearch={handleSearch}
                  setPayload={setPayload}
                  payload={payload}
                  subjects={subjects}
                  daysOfWeek={daysOfWeek}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1">
          {isLoading && (
            <div className="flex mx-auto">
              <Loader />
            </div>
          )}
          {!isLoading && tutorsList && tutorsList.length === 0 && (
            <EmptyState
              title="There are no tutors that match your search."
              desc="Please try adjusting your search keywords or filter"
            />
          )}

          <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-3 md:pt-0 py-[100px]">
            {!isLoading &&
              tutorsList &&
              tutorsList.map(
                ({
                  firstName,
                  lastName,
                  professionalTitle,
                  availabilityType,
                  id,
                  hourlyRate,
                  profilePicture,
                  subject,
                }: any) => (
                  <div
                    key={id}
                    className="bg-white rounded-md shadow-sm overflow-hidden cursor-pointer"
                    onClick={() => {
                      setId(id);
                      setVisible(true);
                    }}
                  >
                    <img
                      src={profilePicture ? profilePicture : pfp}
                      alt="tutor avatar"
                      className="h-[218px] rounded-t-lg w-full bg-[#ddd]"
                    />
                    <div className="p-[16px]">
                      <h3 className="W2STMedium mb-[5px] text-gray900 md:text-[18px] text-[14px]">
                        {firstName + " " + lastName}
                      </h3>
                      <div className="mt-2">
                        <div className="flex gap-3 items-center">
                          <BriefcaseBusiness
                            style={{ color: "text-gray700" }}
                          />
                          <span className="text-gray500 text-sm">
                            {professionalTitle}
                          </span>
                        </div>
                      </div>

                      {/* <div className="mt-2 bg-warning50 rounded-md flex gap-2 items-center p-2 text-sm">
                        <Award size={20} />
                        <span className="text-gray500">
                          15 sessions (5 reviews)
                        </span>
                      </div> */}
                      <AvailabilityBadge availabilityType={availabilityType} />
                      <div className="flex justify-between mt-[16px]">
                        <div>
                          <p className="W2STMedium text-gray900">
                            ${hourlyRate}/hr
                          </p>
                          <h3 className="text-gray500">Hourly rate</h3>
                        </div>
                        <button className="text-white px-[27px] py-[10px] rounded-md bg-primary900 W2STMedium">
                          Book Tutor
                        </button>
                      </div>
                    </div>
                  </div>
                )
              )}
            {/* {tutorsList &&
              tutorsList.map(
                ({
                  firstName,
                  lastName,
                  professionalTitle,
                  availabilityType,
                  id,
                  hourlyRate,
                  profilePicture,
                }: any) => (
                  <div
                    key={id}
                    className="bg-white rounded-md shadow-sm overflow-hidden cursor-pointer"
                    onClick={() => {
                      setId(id);
                      setVisible(true);
                    }}
                  >
                    <img
                      src={profilePicture ? profilePicture : pfp}
                      alt="tutor avatar"
                      className="h-[218px] rounded-t-lg w-full bg-[#ddd]"
                    />
                    <div className="p-[16px]">
                      <h3 className="W2STMedium mb-[5px] text-gray900 md:text-[18px] text-[14px]">
                        {firstName + " " + lastName}
                      </h3>
                      <div className="mt-2">
                        <div className="flex gap-3 items-center">
                          <BriefcaseBusiness
                            style={{ color: "text-gray700" }}
                          />
                          <span className="text-gray500 text-sm">
                            {professionalTitle}
                          </span>
                        </div>
                      </div>

                      <div className="mt-2 bg-warning50 rounded-md flex gap-2 items-center p-2 text-sm">
                        <Award size={20} />
                        <span className="text-gray500">
                          15 sessions (5 reviews)
                        </span>
                      </div>
                      <AvailabilityBadge availabilityType={availabilityType} />
                      <div className="flex justify-between mt-[16px]">
                        <div>
                          <p className="W2STMedium text-gray900">
                            ${hourlyRate}/hr
                          </p>
                          <h3 className="text-gray500">Hourly rate</h3>
                        </div>
                        <button className="text-white px-[27px] py-[10px] rounded-md bg-primary900 W2STMedium">
                          Book Tutor
                        </button>
                      </div>
                    </div>
                  </div>
                )
              )} */}
            <Drawer
              width={window.innerWidth > 768 ? 600 : "100%"}
              title={
                <div className="flex justify-between items-center">
                  <h3>Tutor Details</h3>
                  <X
                    onClick={() => setVisible(false)}
                    className="cursor-pointer"
                  />
                </div>
              }
              open={visible}
              closable={false}
              maskClosable={false}
            >
              {tutorsLoading && <Loader />}
              {!tutorsLoading && tutorsData && (
                <div>
                  <div className="flex gap-2 mb-6">
                    <img
                      src={tutorsData?.data?.profilePicture}
                      className="h-[60px] rounded-full w-[60px]"
                      alt="avatar"
                    />
                    <div className="flex-1">
                      <h3 className="W2STMedium mb-[5px] text-gray900 md:text-[18px] text-[14px]">
                        {tutorsData?.data?.firstName +
                          " " +
                          tutorsData?.data?.lastName}
                      </h3>
                      <div className="mt-2">
                        <div className="flex gap-3 items-center">
                          <BriefcaseBusiness
                            size={20}
                            style={{ color: "text-gray700" }}
                          />
                          <span className="text-gray500">
                            {tutorsData?.data?.professionalTitle}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Tabs defaultActiveKey="1" className="w-full">
                    <Tabs.TabPane
                      tab={
                        <span className="flex items-center gap-2">
                          <Calendar size={16} />
                          Book Session
                        </span>
                      }
                      key="1"
                    >
                      <div className="py-4">
                        <TutorBookingStepper id={id} setVisible={setVisible} />
                      </div>
                    </Tabs.TabPane>

                    <Tabs.TabPane
                      tab={
                        <span className="flex items-center gap-2">
                          <BriefcaseBusiness size={16} />
                          Experience
                        </span>
                      }
                      key="2"
                    >
                      <div className="py-4 space-y-4">
                        {tutorsData?.data?.workExperience?.map((exp: any) => (
                          <div
                            key={exp._id}
                            className="bg-gray-50 p-4 rounded-lg"
                          >
                            <div className="flex justify-between items-start">
                              <h5 className="font-medium text-gray-900">
                                {exp.title}
                              </h5>
                              <span className="text-sm text-gray-500">
                                {new Date(exp.startDate).toLocaleDateString(
                                  "en-US",
                                  {
                                    month: "short",
                                    year: "numeric",
                                  }
                                )}{" "}
                                -{" "}
                                {exp.endDate
                                  ? new Date(exp.endDate).toLocaleDateString(
                                      "en-US",
                                      {
                                        month: "short",
                                        year: "numeric",
                                      }
                                    )
                                  : "Present"}
                              </span>
                            </div>
                            <p className="text-gray-600 text-sm mt-1">
                              {exp.company}
                            </p>
                            <p className="text-gray-500 text-sm mt-2">
                              {exp.description}
                            </p>
                          </div>
                        ))}
                        {(!tutorsData?.data?.workExperience ||
                          tutorsData?.data?.workExperience.length === 0) && (
                          <div className="text-center text-gray-500 py-8">
                            No work experience listed
                          </div>
                        )}
                      </div>
                    </Tabs.TabPane>

                    <Tabs.TabPane
                      tab={
                        <span className="flex items-center gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                          </svg>
                          Education
                        </span>
                      }
                      key="3"
                    >
                      <div className="py-4 space-y-4">
                        {tutorsData?.data?.education?.map((edu: any) => (
                          <div
                            key={edu._id}
                            className="bg-gray-50 p-4 rounded-lg"
                          >
                            <div className="flex justify-between items-start">
                              <h5 className="font-medium text-gray-900">
                                {edu.college}
                              </h5>
                              <span className="text-sm text-gray-500">
                                {new Date(edu.enrolled).toLocaleDateString(
                                  "en-US",
                                  {
                                    month: "short",
                                    year: "numeric",
                                  }
                                )}{" "}
                                -{" "}
                                {edu.graduated
                                  ? new Date(edu.graduated).toLocaleDateString(
                                      "en-US",
                                      {
                                        month: "short",
                                        year: "numeric",
                                      }
                                    )
                                  : "Present"}
                              </span>
                            </div>
                            <p className="text-gray-600 text-sm mt-1">
                              {edu.degree} in {edu.majors}
                            </p>
                          </div>
                        ))}
                        {(!tutorsData?.data?.education ||
                          tutorsData?.data?.education.length === 0) && (
                          <div className="text-center text-gray-500 py-8">
                            No education history listed
                          </div>
                        )}
                      </div>
                    </Tabs.TabPane>
                  </Tabs>
                </div>
              )}
            </Drawer>
          </div>
        </div>
      </div>
    </StudentDashboard>
  );
};

export default StudentTutors;
